import { buildPrescriptionText } from "../screen/telemedicine/tinodeChat/tinodeComponent/SendPrescriptionDialog";
import { loadOlderMessages } from "./tinodeApi";

export const SESSION_END_MARKER = "__session_end__";

export const isSessionEndMessage = (msg) => {
  if (!msg) return false;
  try {
    const content = msg.content;
    if (typeof content === "string") {
      return content.includes(SESSION_END_MARKER);
    }
    if (content?.txt) {
      return content.txt.includes(SESSION_END_MARKER);
    }
    if (content?.ent || content?.fmt) {
      return (content.txt || "").includes(SESSION_END_MARKER);
    }
  } catch (_) {}
  return false;
};

// export const sendDoctorGreeting = async (
//   tinode,
//   topicName,
//   doctorName = null,
// ) => {
//   try {
//     if (!tinode || !topicName) return null;

//     const topic = tinode.getTopic(topicName);
//     if (!topic || !topic.isSubscribed()) {
//       console.warn("sendDoctorGreeting: topic not subscribed");
//       return null;
//     }

//     const name = doctorName || tinode.getMeTopic()?.public?.fn || "Dokter";
//     const greetingText =
//       `Halo! Saya ${name}. 👋\n\n` +
//       `Selamat datang di sesi konsultasi. Saya siap membantu Anda hari ini.\n\n` +
//       `Silakan ceritakan keluhan atau pertanyaan Anda. 😊`;

//     const pubMsg = topic.createMessage(greetingText, false);
//     const result = await topic.publishDraft(pubMsg, Promise.resolve());

//     const realSeq = result?.params?.seq || result?.seq;

//     try {
//       await loadOlderMessages(tinode, topicName, 10, (realSeq || 999999) + 1);
//     } catch (_) {}

//     if (process.env.NODE_ENV === "development") {
//       console.log("✅ Greeting sent, seq:", realSeq);
//     }

//     return { seq: realSeq, content: greetingText };
//   } catch (err) {
//     console.warn("⚠️ sendDoctorGreeting failed:", err?.message || err);
//     return null;
//   }
// };

export const sendDoctorNotes = async (tinode, topicName, notesText) => {
  try {
    if (!tinode || !topicName || !notesText?.trim()) return null;

    const topic = tinode.getTopic(topicName);
    if (!topic || !topic.isSubscribed()) {
      console.warn("sendDoctorGreeting: topic not subscribed");
      return null;
    }

    const pubMsg = topic.createMessage(notesText.trim(), false);
    const result = await topic.publishDraft(pubMsg, Promise.resolve());
    const realSeq = result?.params?.seq || result?.seq;

    // Force pull dari server agar cache lokal terupdate
    try {
      await loadOlderMessages(tinode, topicName, 10, (realSeq || 999999) + 1);
    } catch (_) {}

    if (process.env.NODE_ENV === "development") {
      console.log("✅ Greeting sent, seq:", realSeq);
    }

    return { seq: realSeq, content: notesText };
  } catch (err) {
    console.warn("⚠️ sendDoctorGreeting failed:", err?.message || err);
    return null;
  }
};

export const sendDoctorPrescription = async (
  tinode,
  topicName,
  prescriptionList,
) => {
  try {
    if (!tinode || !topicName || !prescriptionList?.length) return null;

    const topic = tinode.getTopic(topicName);
    if (!topic || !topic.isSubscribed()) {
      console.warn("sendDoctorPrescription: topic not subscribed");
      return null;
    }

    const prescriptionText = buildPrescriptionText(prescriptionList);
    if (!prescriptionText.trim()) return null;

    const pubMsg = topic.createMessage(prescriptionText.trim(), false);
    const result = await topic.publishDraft(pubMsg, Promise.resolve());
    const realSeq = result?.params?.seq || result?.seq;

    try {
      await loadOlderMessages(tinode, topicName, 10, (realSeq || 999999) + 1);
    } catch (_) {}

    if (process.env.NODE_ENV === "development") {
      console.log("✅ Prescription sent, seq:", realSeq);
    }

    return { seq: realSeq, content: prescriptionText };
  } catch (err) {
    console.warn("⚠️ sendDoctorPrescription failed:", err?.message || err);
    return null;
  }
};

export const endConsultationSession = async (
  tinode,
  topicName,
  endedBy = "doctor",
) => {
  if (!tinode || !topicName) throw new Error("Tinode dan topicName diperlukan");

  const topic = tinode.getTopic(topicName);
  if (!topic) throw new Error("Topic tidak ditemukan");
  if (!topic.isSubscribed()) throw new Error("Topic belum di-subscribe");

  const endMessage =
    endedBy === "doctor"
      ? `Sesi konsultasi telah diakhiri oleh dokter. Terima kasih. 🏥 ${SESSION_END_MARKER}`
      : `Sesi konsultasi telah diakhiri. Terima kasih. 🏥 ${SESSION_END_MARKER}`;

  const pubMsg = topic.createMessage(endMessage, false);
  await topic.publishDraft(pubMsg, Promise.resolve());
};

export const isSessionEndedFromMessages = (topic) => {
  if (!topic) return false;
  let ended = false;
  try {
    topic.allMessages((msg) => {
      if (isSessionEndMessage(msg)) ended = true;
    });
  } catch (_) {}
  return ended;
};
